/**
 * 内部收款单列表页面权限
 */
export const INTERNAL_COLLECTION_LIST_PAGE_UUID =
  'c6974f91-4121-489f-9d49-4cfcfaa81868'

/* -------------------------------------------------------------------------- */
/*                                    待匹配                                   */
/* -------------------------------------------------------------------------- */
export const INTERNAL_COLLECTION_WAIT_MATCH_MANAGE_ACTION_UUID =
  '1291d9b8-23c4-4416-91db-b2a89a240c76'

/* -------------------------------------------------------------------------- */
/*                                    待入金                                   */
/* -------------------------------------------------------------------------- */
export const INTERNAL_COLLECTION_WAIT_RECHARGE_MANAGE_ACTION_UUID =
  '2a13f6b6-37cb-4765-a373-553d2d6dcd17'

/* -------------------------------------------------------------------------- */
/*                                    待审核                                   */
/* -------------------------------------------------------------------------- */
export const INTERNAL_COLLECTION_WAIT_AUDIT_MANAGE_ACTION_UUID =
  '14b7222a-194b-4488-a134-66e6803ee55c'

/* -------------------------------------------------------------------------- */
/*                                    非保证金                                    */
/* -------------------------------------------------------------------------- */
export const INTERNAL_COLLECTION_ABANDON_MANAGE_ACTION_UUID =
  '60066371-7f7a-4c6c-96f0-c3ee1e1e20a7'
